export default __webpack_public_path__ + "static/media/classic.06d44fd0.png";